import { computed, ComputedRef, DeepReadonly, readonly, ref, unref } from 'vue'
import { useTimers } from './timers'
import { Timers } from '../types/timers'
import { defineStore, storeToRefs } from 'pinia'
import { MaybeRef } from '@vueuse/core'
import { format } from 'date-fns'

type UseAllTimersReturn = {
  /**Returns all timers from all days on device */
  getAllTimersOnDevice: ComputedRef<DeepReadonly<Timers[]>>
  /**Sets timers for every day on device except the current day */
  setPreviousDaysTimers: (data: Timers[]) => void
  resetStoreState: () => void
  /**deletes timers by date (format MM-dd-yyy) */
  deleteByDate: (date: string) => Promise<void>
}

//Store for all timers for all days on device.
export const useAllTimers = defineStore('allDeviceTimers', (): UseAllTimersReturn => {
  const previousDaysTimers = ref<Timers[]>([])

  const setPreviousDaysTimers = (data: MaybeRef<Timers[]>) => {
    previousDaysTimers.value = unref(data)
  }

  const getAllTimersOnDevice = computed((): DeepReadonly<Timers[]> => {
    const { getAllParentTimers } = storeToRefs(useTimers())
    return readonly([unref(getAllParentTimers), ...unref(previousDaysTimers)])
  })
  const resetStoreState = () => {
    previousDaysTimers.value = []
  }
  const deleteByDate = async (date: string) => {
    const prevIndex = previousDaysTimers.value.findIndex((timers) => {
      if (timers[0]) {
        //return if the day is the same
        return date == format(new Date(timers[0].start_time), 'MM-dd-yyyy')
      } else {
        return false
      }
    })

    //if exists delete it
    if (prevIndex > -1) {
      previousDaysTimers.value.splice(prevIndex, 1)
    }
  }
  return {
    getAllTimersOnDevice,
    setPreviousDaysTimers,
    resetStoreState,
    deleteByDate,
  }
})
